export default __webpack_public_path__ + "static/media/caret-left.4a25bc87.svg";